export const SUPPORT_EVENTS = [
  'landing_page_passed',
  'login_screen_loaded',
  'email_sign_up_button_clicked',
  'google_continue_sign_up_passed',
  'apple_continue_sign_up_passed',
  'email_enter_screen_passed',
  'code_screen_passed',
  'check_email_screen_loaded',
  'name_screen_passed',
  'dob_screen_passed',
  'gender_screen_passed',
  'looking_for_screen_passed',
  'goal_screen_passed',
  'interests_screen_passed',
  'height_screen_passed',
  'weight_screen_passed',
  'sexual_orientation_screen_passed',
  'star_sign_screen_passed',
  'sport_screen_passed',
  'education_level_screen_passed',
  'marital_status_screen_passed',
  'kids_screen_passed',
  'drink_screen_passed',
  'smoke_screen_passed',
  'pets_screen_passed',
  'religion_screen_passed',
  'value_screen_passed',
  'about_screen_passed',
  'photo_screen_passed',
  'sign_in',
  'phone_screen_passed',
  'demo_app_passed',
  'match.link.opened',
] as const;
